import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import SVG from "react-inlinesvg"
import Modal from '@app/components/ui/modals/Modal'
import Body from '@app/components/shared/StudentsTable/Body'
import Form from '@app/components/shared/StudentsTable/Form'
import PretendLink from '@app/components/ui/buttons/PretendLink'
import ShareLoginsButton from '@app/components/shared/instructions/ShareLoginsButton'

import _ from 'lodash'
import addIcon from '@icons/people/add'

class StudentsTable extends Component {
  constructor (props) {
    super(props)

    this.handleAdd = this.handleAdd.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.modal = createRef(null);
  }

  handleAdd(e) {
    this.modal.current.open()
  }

  handleSave(e) {
    this.modal.current.close()
  }

  render() {
    const { config, boundActions, student, ...rest } = this.props

    return (
      <div className="students-table">
        <div className="separator m-0" />
        <Body
          config={config}
          createStudentAction={boundActions.addChild}
          updateStudentAction={boundActions.updateChild}
          deleteStudentAction={boundActions.deleteChild}
          {...rest}
        />

        <div className="separator mt-0 mb-2" />
        <div className="content-indent grid grid--sm-1 grid--md-2 grid--xl-2">
          <ShareLoginsButton
            students={this.props.students}
            filename="credentials.csv"
          />

          <a
            href="javascript:void(0)"
            onClick={this.handleAdd}
            className="btn btn--light-blue link--icon-left f--upper"
            id="addStudentsButton"
          >

            <SVG src={addIcon} />
            { I18n.t("js.students_table.add_child") }
          </a>
        </div>

        <Modal ref={this.modal} className="modal--md">
          <h1 className="modal__title">
            { I18n.t('js.students_table.add_child') }
          </h1>
          <Form
            {...this.props}
            onSave={this.handleSave}
            createStudentAction={boundActions.addChild}
            updateStudentAction={boundActions.updateChild}
            deleteStudentAction={boundActions.deleteChild}
          />
        </Modal>
      </div>
    )
  }
}

StudentsTable.propTypes = {
  config: PropTypes.object.isRequired,
  global: PropTypes.object.isRequired,
  students: PropTypes.array.isRequired,
  updatedOn: PropTypes.number,
  boundActions: PropTypes.object.isRequired
}

export default StudentsTable
